module.exports = __webpack_public_path__ + "static/media/choquetermico.ddd04ced.jpg";